/** When set to '1', institution leader has entered Skylite desktop this session (hub hidden until reset). */
export const INSTITUTION_DESKTOP_SESSION_KEY = 'skylite_institution_desktop';

/** Owner-only: JSON string of selected dummy user for institution hub preview. */
export const SUPPORT_PREVIEW_USER_KEY = 'skylite_support_preview_user';

/** Owner-only: '1' while viewing institution analytics hub as preview (not owner cards hub). */
export const OWNER_INSTITUTION_PREVIEW_ACTIVE_KEY = 'skylite_owner_institution_preview_active';

/**
 * Set before impersonation redirect / while impersonation is active.
 * Boot scripts read this so Google Translate never starts Arabic on `/` before React loads.
 */
export const IMPERSONATION_ENGLISH_CHROME_KEY = 'skylite_impersonation_english_chrome';

export const INSTITUTION_HUB_PATH = '/institution-hub';

/** Owner console home (search, renewals, support) — distinct from institution preview. */
export const OWNER_ADMIN_HUB_PATH = '/owner';

/** Paths/session that must render English chrome before first paint (no Arabic flash). */
export function shouldForceEnglishChromeAtBoot() {
  try {
    if (typeof window === 'undefined') return false;
    if (window.__skyliteForceEnglishChrome === true) return true;
    const rawPath = window.location.pathname || '/';
    const path = rawPath.replace(/\/+$/, '') || '/';
    if (path === OWNER_ADMIN_HUB_PATH || path === INSTITUTION_HUB_PATH) return true;
    if (path.startsWith(`${OWNER_ADMIN_HUB_PATH}/`) || path.startsWith(`${INSTITUTION_HUB_PATH}/`)) return true;
    if (sessionStorage.getItem(OWNER_INSTITUTION_PREVIEW_ACTIVE_KEY) === '1') return true;
    if (sessionStorage.getItem('skylite_owner_hub_nav_intent') === '1') return true;
    if (sessionStorage.getItem('skylite_owner_desktop_mode') === '1') return true;
    if (sessionStorage.getItem(IMPERSONATION_ENGLISH_CHROME_KEY) === '1') return true;
    return false;
  } catch {
    return false;
  }
}

/** True while owner is impersonating (session flag survives until Exit impersonation). */
export function readImpersonationEnglishChrome() {
  try {
    return sessionStorage.getItem(IMPERSONATION_ENGLISH_CHROME_KEY) === '1';
  } catch {
    return false;
  }
}

export function setImpersonationEnglishChrome() {
  try {
    sessionStorage.setItem(IMPERSONATION_ENGLISH_CHROME_KEY, '1');
    window.__skyliteForceEnglishChrome = true;
  } catch {
    /* ignore */
  }
}

export function clearImpersonationEnglishChrome() {
  try {
    sessionStorage.removeItem(IMPERSONATION_ENGLISH_CHROME_KEY);
  } catch {
    /* ignore */
  }
}

export function readInstitutionDesktopEntered() {
  try {
    return sessionStorage.getItem(INSTITUTION_DESKTOP_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function setInstitutionDesktopEntered() {
  try {
    sessionStorage.setItem(INSTITUTION_DESKTOP_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearInstitutionDesktopEntered() {
  try {
    sessionStorage.removeItem(INSTITUTION_DESKTOP_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function readSupportPreviewUser() {
  try {
    const raw = sessionStorage.getItem(SUPPORT_PREVIEW_USER_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o !== 'object' || !o.id) return null;
    return o;
  } catch {
    return null;
  }
}

export function writeSupportPreviewUser(user) {
  try {
    if (user == null) sessionStorage.removeItem(SUPPORT_PREVIEW_USER_KEY);
    else sessionStorage.setItem(SUPPORT_PREVIEW_USER_KEY, JSON.stringify(user));
  } catch {
    /* ignore */
  }
}

export function readOwnerInstitutionPreviewActive() {
  try {
    return sessionStorage.getItem(OWNER_INSTITUTION_PREVIEW_ACTIVE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setOwnerInstitutionPreviewActive() {
  try {
    sessionStorage.setItem(OWNER_INSTITUTION_PREVIEW_ACTIVE_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearOwnerInstitutionPreviewActive() {
  try {
    sessionStorage.removeItem(OWNER_INSTITUTION_PREVIEW_ACTIVE_KEY);
  } catch {
    /* ignore */
  }
}

export function clearAllOwnerPreviewSession() {
  clearOwnerInstitutionPreviewActive();
  writeSupportPreviewUser(null);
}
